import { getAmplitudeInstance } from '../amplitudeHelpers';
import ProductsAvailable from '../enums/ProductsAvailable';
import PurchaseScreenTypePlan from '../enums/PurchaseScreenTypePlan';
import UpsellTrigger from '../enums/UpsellTrigger';

type logUpsellShownParams = {
  products_available?: ProductsAvailable;
  purchase_screen_type_plan?: PurchaseScreenTypePlan;
  trigger?: UpsellTrigger;
};

/**
 * User sees any upsell
 * @param params - Attributes to log with the amplitude event
 * @param params.products_available - The combination of available products offered on an upsell (plus, plus-peak, peak).
 * @param params.purchase_screen_type_plan - The plan shown on the pro purchasing event occurs on (e.g. trial, non-trial, promo, etc.)
 * @param params.trigger - Action that triggered the upsell to display
 */
const logUpsellShown = ({ products_available, purchase_screen_type_plan, trigger }: logUpsellShownParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent(
    'upsell shown',
    { 'products available': products_available, 'purchase screen type plan': purchase_screen_type_plan, trigger },
    callback
  );
};

export default logUpsellShown;
